import { api, setAccessToken } from "@/lib/api";
import { setStoredToken } from "@/lib/token-store";

export type AccessInviteValidation =
  | { valid: true; inviteId: string; invitedByName: string | null }
  | { valid: false; reason: "not_found" | "expired" | "revoked" };

export type OwnedAccessInvite = {
  code: string;
  redeemedByName: string | null;
  redeemedAt: string | null;
  createdAt: string;
};

export async function joinWaitlist(email: string, name?: string) {
  return api.post<{ ok: true }>("/access/waitlist", { email, name });
}

export async function verifyInviteCode(code: string) {
  return api.get<AccessInviteValidation>(`/access/invite/${encodeURIComponent(code)}`);
}

export async function signUpWithInvite(
  code: string,
  email: string,
  password: string,
  name: string,
) {
  const { data, error } = await api.post<{
    token: string;
    user: { id: string; email: string; name: string; image?: string | null };
  }>("/access/sign-up", {
    code,
    email,
    password,
    name,
  });
  if (data?.token) {
    setAccessToken(data.token);
    setStoredToken(data.token);
  }
  return { data, error };
}

export async function listMyInvites() {
  return api.get<OwnedAccessInvite[]>("/access/invites");
}

export async function createMyInvite() {
  return api.post<{ code: string }>("/access/invites");
}
